(function () {
  "use strict";

  angular
    .module("app")
    .directive("avoidFavorsPanel", avoidFavorsPanel);

  avoidFavorsPanel.$inject = [];

  function avoidFavorsPanel() {
    // Usage: Display avoid favor sets list info
    //
    var directive = {
      bindToController: true,
      controller: avoidFavorsPanelController,
      controllerAs: "vm",
      scope: {
        avoidFavorsSetList: "="
      },
      restrict: "E",
      templateUrl: "/app/avoidFavors/avoidFavors.template.html"
    };
    return directive;

  }

  avoidFavorsPanelController.$inject = ["$scope", "$rootScope", "_", "$http", "UserProvider", "mapService", "userService", "routeExceptionService", "routeExceptionsLayerService"]
  function avoidFavorsPanelController($scope, $rootScope, _, $http, UserProvider, mapService, userService, routeExceptionService, routeExceptionsLayerService) {
    var vm = this;
    vm.sets = [];
    vm.updateResult = updateResult;
    vm.isAvoidFavorsVisible = isAvoidFavorsVisible;
    init();

    function init() {
      vm.sets = angular.copy(userService.getAvoidFavorsSets());
      if (vm.avoidFavorsSetList && vm.avoidFavorsSetList !== "") {
        var temp = vm.avoidFavorsSetList.split(",").map(Number);
        _.forEach(vm.sets, (s) => {
          if (_.indexOf(temp, s.SetID) > -1) {
            s.visible = true;
          }
        });
      }
    }

    function isAvoidFavorsVisible() {
      return routeExceptionsLayerService.isAvoidFavorsLayerVisible();
    }

    // function getSelectedSetsLength() {
    //   return _.reduce(vm.sets, (sum, s) => (s.visible) ? ++sum : sum, 0);
    // }

    function updateResult(set) {
      var selectedSets = _.transform(vm.sets, (rst,s) => {
        if (s.visible) {
          return rst.push(s.SetID);
        }
      }, []);
      vm.avoidFavorsSetList = selectedSets.join();
    }

    $scope.$on("resetAFSelection", function (event, message) {
      _.forEach(vm.sets, set => {
        set.visible = false;
      });
    });
  }
})();




// WEBPACK FOOTER //
// ./app/avoidFavors/avoidFavorsPanel.directive.js